<main class="login-page" dir="rtl">
  <div class="login-shell">
    <div class="login-card">
      <div class="login-header">
        <div>
          <span class="login-brand">راهداری GPS</span>
          <h1>تغییر رمز عبور کارشناس</h1>
        </div>
        <a class="close-button" routerLink="/home" aria-label="بازگشت به صفحه اصلی">
          <mat-icon aria-hidden="true">close</mat-icon>
        </a>
      </div>

      <form #ngForm="ngForm" (ngSubmit)="submit(ngForm)">
        <div class="login-body">
          <p class="form-intro">اطلاعات خود را وارد کنید.</p>

          <label for="oldPasswordField">رمز عبور قدیمی</label>
          <div class="form-group has-icon">
            <span class="form-control-icon"><mat-icon aria-hidden="true">lock_outline</mat-icon></span>
            <input type="password" class="form-control" name="oldPasswordField" id="oldPasswordField" [disabled]="isSubmitDisabled" [(ngModel)]="fields.strOldPassword" required autocomplete="current-password" placeholder="رمز عبور قدیمی" />
          </div>

          <label for="newPasswordField">رمز عبور جدید</label>
          <div class="form-group has-icon">
            <span class="form-control-icon"><mat-icon aria-hidden="true">lock_outline</mat-icon></span>
            <input type="password" class="form-control" name="newPasswordField" id="newPasswordField" [disabled]="isSubmitDisabled" [(ngModel)]="fields.strNewPassword" required autocomplete="new-password" placeholder="رمز عبور جدید" />
          </div>

          <label for="newPasswordRepeatField">تکرار رمز عبور جدید</label>
          <div class="form-group has-icon">
            <span class="form-control-icon"><mat-icon aria-hidden="true">lock_outline</mat-icon></span>
            <input type="password" class="form-control" name="newPasswordRepeatField" id="newPasswordRepeatField" [disabled]="isSubmitDisabled" [(ngModel)]="fields.strNewPasswordRepeat" required autocomplete="new-password" placeholder="تکرار رمز عبور جدید" />
          </div>
        </div>

        <div class="login-footer">
          <button type="submit" class="submit-button" [disabled]="ngForm.invalid || ngForm.pristine || isSubmitDisabled">تغییر رمز عبور</button>
        </div>
      </form>
    </div>
  </div>
</main>
